import React, { useState } from "react";

export const LogData = ({ data }) => {
  const [showMore, setShowMore] = useState(true);
  const [showLess, setShowLess] = useState(false);

  return (
    <div>
      <div>
        <ul style={{ listStyleType: "disc" }}>
          {showMore && data.length > 2
            ? data.slice(0, 2).map((item, index) => (
                <li key={index} className="text-secondary">
                  <span>{item.action.label.text} |</span>
                  <span> {item.date}</span>
                </li>
              ))
            : data.map((item, index) => (
                <li key={index} className="text-secondary">
                  <span>{item.action.label.text} |</span>
                  <span> {item.date}</span>
                </li>
              ))}
        </ul>
        {!showLess && data.length > 2 && (
          <button
            style={{
              padding: "0px",
              border: "none",
              background: "none",
              fontWeight: "600",
              color: "#487ED8",
            }}
            onClick={() => {
              setShowMore(false);
              setShowLess(true);
            }}
          >
            Show more
          </button>
        )}
        {!showMore && data.length > 2 && (
          <button
            style={{
              padding: "0px",
              border: "none",
              background: "none",
              fontWeight: "600",
              color: "#487ED8",
            }}
            onClick={() => {
              setShowLess(false);
              setShowMore(true);
            }}
          >
            Show less
          </button>
        )}
      </div>
    </div>
  );
};
